var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { attrs: { id: "setting-container" } },
      [
        _c(
          "b-row",
          [
            _c(
              "b-col",
              { attrs: { cols: "12" } },
              [
                _c(
                  "b-row",
                  [
                    _c("b-col", { attrs: { cols: "10" } }, [
                      _vm._v("\n            Mobile\n          ")
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { cols: "2" } },
                      [
                        _c("j-toggle", {
                          attrs: { disabled: false },
                          model: {
                            value: _vm.reminder.mobile,
                            callback: function($$v) {
                              _vm.$set(_vm.reminder, "mobile", $$v)
                            },
                            expression: "reminder.mobile"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c("b-col", { attrs: { cols: "10" } }, [
                      _vm._v("\n            Email\n          ")
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { cols: "2" } },
                      [
                        _c("j-toggle", {
                          attrs: { disabled: false },
                          model: {
                            value: _vm.reminder.email,
                            callback: function($$v) {
                              _vm.$set(_vm.reminder, "email", $$v)
                            },
                            expression: "reminder.email"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form-group",
                          [
                            _c("label", [_vm._v("Set Reminder Before")]),
                            _vm._v(" "),
                            _c("j-single-select", {
                              attrs: {
                                options: _vm.options_reminder,
                                placeholder: "Select",
                                "value-format": "object",
                                label: "name"
                              },
                              model: {
                                value: _vm.reminder.reminderBefore,
                                callback: function($$v) {
                                  _vm.$set(_vm.reminder, "reminderBefore", $$v)
                                },
                                expression: "reminder.reminderBefore"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    staticClass: "btn blue pull-right",
                    on: {
                      click: function($event) {
                        _vm.reminderConfig()
                      }
                    }
                  },
                  [_vm._v("\n          Apply\n        ")]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cf37e3ce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cf37e3ce","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/board/tabs/jBoardReminderTab.vue
// module id = null
// module chunks = 